import { render, staticRenderFns } from "./acdetail.vue?vue&type=template&id=3e636396&scoped=true&"
import script from "./acdetail.vue?vue&type=script&lang=js&"
export * from "./acdetail.vue?vue&type=script&lang=js&"
import style0 from "./acdetail.vue?vue&type=style&index=0&id=3e636396&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e636396",
  null
  
)

export default component.exports